import { jsonMember, jsonObject } from 'typedjson';
import { Uuid } from '@core/uuid/uuid';

@jsonObject
export class RegulationPreviewResponse {
  @jsonMember readonly id!: Uuid;
  @jsonMember readonly content!: string;
}
